// extracted by mini-css-extract-plugin
module.exports = {"centered":"centered--2jPzzRFL","emoji":"emoji--3gU-a8nl","title":"title--sRRm2SCk"};